import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./Contactus.css";
import { REACT_APP_API_BASE_URL } from "../../../../env";

const API_BASE_URL = REACT_APP_API_BASE_URL;

const Contactus = () => {
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [showCallModal, setShowCallModal] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const createdBy = localStorage.getItem("companyId");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    setSuccess("");
    try {
      const res = await fetch(`${API_BASE_URL}/ticket`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title, description, createdBy }),
      });
      if (!res.ok) throw new Error("Failed to submit ticket");
      setSuccess(
        "Thank you for submitting your ticket. Our support team will review your request and get back to you as soon as possible."
      );
      setTitle("");
      setDescription("");
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-fluid contactus-bg d-flex flex-column justify-content-center align-items-center h-100">
      <div className="w-100" style={{ maxWidth: 420 }}>
        <div className="text-center contactus-header mb-1 mt-4">
          CONTACT US:
        </div>

        <button
          className="contactus-btn contactus-btn-call w-100 mb-4"
          onClick={() => setShowCallModal(true)}
        >
          CALL US
        </button>

        <button
          className="contactus-btn contactus-btn-email w-100 mb-5"
          onClick={() =>
            window.open("https://somadome.com/contact-support/", "_blank")
          }
        >
          EMAIL US
        </button>

        <div className="text-center contactus-support-header mb-1">
          NEED SUPPORT?
        </div>

        <button
          className="contactus-btn contactus-btn-ticket w-100 mb-2"
          onClick={() =>
            window.open("https://somadome.com/contact-support/", "_blank")
          }
        >
          SUBMIT A TICKET
        </button>
      </div>

      {/* Ticket Modal */}
      <Modal show={showTicketModal} onHide={() => setShowTicketModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Submit a Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="ticketTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
                placeholder="Enter ticket title"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="ticketDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
                placeholder="Describe your issue"
              />
            </Form.Group>
            {error && <div className="text-danger mb-2">{error}</div>}
            {success && <div className="text-success mb-2">{success}</div>}
            <Button
              variant="primary"
              type="submit"
              disabled={submitting}
              className="w-100"
            >
              {submitting ? "Submitting..." : "Submit Ticket"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Call Modal */}
      <Modal show={showCallModal} onHide={() => setShowCallModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Call Support</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>Please call us at:</p>
          <h4>+1-888-426-5789</h4>
          <Button
            variant="primary"
            className="mt-3 w-100"
            onClick={() => setShowCallModal(false)}
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Contactus;
